export const WORDS = [
    "naush"
];